import Card from './Card';
import './App.css';
import { useState } from 'react';

function App() {
  let [checkPricing,setCheckPricing] = useState(false)

  const prices = {
    monthly : [
      {
        type : 'Basic',
        amount : 19.99,
        details : [
          {storage : '50 GB' ,
          users : 2,
          send : "3 GB"}
        ]
      },
      {
        type : 'Professional',
        amount : 24.99,
        details : [
          {storage : '1 TB' ,
          users : 5,
          send : "10 GB"}
        ]
      },
      {
        type : 'Master',
        amount : 39.99,
        details : [
          {storage : '2 TB' ,
          users : 10,
          send : "20 GB"}
        ]
      }
    ],
    annually : [
      {
        type : 'Basic',
        amount : 199.99,
        details : [
          {storage : '500 GB',
           users : 2,
           send : '3 GB'
        }
        ]
      },
      {
        type : 'Professional',
        amount : 249.99,
        details : [
          {storage : '1 TB' ,
          users : 5,
          send : "10 GB"}
        ]
      },
      {
        type : 'Master',
        amount : 399.99,
        details : [
          {storage : '2 TB' ,
            users : 10,
            send : "20 GB"}
        ]
      }
    ]
  }
    let pricing;
    checkPricing !== true ?  pricing = prices.annually : pricing = prices.monthly

  return (
    <main className="App ">
        <section className='my-10'>
           <h1 className='App-heading'>Our Pricing</h1>
           <div className='App-toggle'>
              <p>Annually</p>
              <label className='switch mx-6'>
                <input type="checkbox" autoFocus value={checkPricing} onChange={e => setCheckPricing(!checkPricing)}/>
                <span className='bg-secondary-500'></span>
              </label>
              <p>Monthly</p>
           </div>
        </section>
        <div className='App-card_component'>
            {pricing.map((price,id) => (
              <Card {...price} key={id}/>
            ))}
        </div> 
    </main>
  );
}

export default App;
